// import react components
import { createContext } from "react";

const ExpiryTimestampContext = createContext();

export default ExpiryTimestampContext;
